import { useQuery } from 'react-query'

import StoreService from '@/store/StoreService'

export function useQueryUserPlaylists() {
  const { playlistService } = StoreService.getStore()

  const { queries } = playlistService

  const { queryFn, queryKey } = queries.userPlaylists

  return useQuery(queryKey, queryFn, {
    // 24 hours
    cacheTime: 1000 * 60 * 60 * 24 * 7,

    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24 // 7 days
  })
}
